import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { CHAAT_CORNER } from "../../../constants/Constants";
require("./booth.scss");

class ChaatCorner extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Chaat Cart</div>
        <Card.Img
          className="booth-image"
          src="https://nbcf.s3-us-west-1.amazonaws.com/resonate/PRODUCT0269-H-Bhel-Purijpg.jpg"
        />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {CHAAT_CORNER.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default ChaatCorner;
